import React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { DataTable } from '../../../../ui';
import { MOCK_SECURITY_LOGS } from '../constants';
import { getSecurityLogColumns } from '../functions';

export const SecurityLogTab: React.FC = () => {
  const columns = getSecurityLogColumns();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
      <Box>
        <Typography variant="h4" sx={{ fontWeight: 900, color: 'text.primary', letterSpacing: '-0.03em', mb: 0.5 }}>
          Security & Audit Log
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary', fontWeight: 500 }}>
          Track all administrative actions and security-related events.
        </Typography>
      </Box>

      <Paper variant="outlined" sx={{ overflow: 'hidden' }}>
        <DataTable
          columns={columns}
          data={MOCK_SECURITY_LOGS}
          rowsPerPage={10}
          totalRecords={MOCK_SECURITY_LOGS.length}
          totalPages={1}
          currentPage={1}
          onPageChange={() => {}}
        />
      </Paper>
    </Box>
  );
};
